import { Box } from "@mui/material";

interface BannerPropsInterface {
  children: JSX.Element;
  background: string;
  height: string;
}

export const Banner = ({
  children,
  background,
  height = "270px",
}: BannerPropsInterface) => {
  return (
    <Box
      sx={{
        borderRadius: "0.90rem",
        position: "relative",
        backgroundColor: "#000000",
        width: "100%",
        height,
        marginBottom: "30px",
        color: "white",
        "&::before": {
          borderRadius: "0.90rem",
          content: "' '",
          display: "block",
          position: "absolute",
          left: 0,
          top: 0,
          width: "100%",
          height: "100%",
          opacity: "0.8",
          background,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          zIndex: 0,
        },
      }}
    >
      {children}
    </Box>
  );
};
